export const adminAccounts = {
  "admin.accounts.pageTitle": "Kontenverwaltung",
  "admin.accounts.pageDescription": "Alle Benutzerkonten im System verwalten und anzeigen",
  "admin.accounts.title": "Kontenverwaltung", 
  "admin.accounts.subtitle": "Alle Benutzerkonten mit umfassenden Filter- und Sortieroptionen anzeigen und verwalten",
  "admin.accounts.errorTitle": "Fehler beim Laden der Konten",
  "admin.accounts.errorMessage": "Fehler beim Laden der Kontodaten. Bitte versuchen Sie es erneut.",
  "admin.accounts.retryButton": "Erneut versuchen",

  // Filters section
  "admin.accounts.filters.title": "Kontenfilter",
  "admin.accounts.filters.accountInformationTitle": "Kontoinformationen",
  "admin.accounts.filters.dateRangeTitle": "Datumsbereich",
  "admin.accounts.filters.balanceRangeTitle": "Saldobereich",
  "admin.accounts.filters.accountNumber": "Kontonummer",
  "admin.accounts.filters.accountNumberPlaceholder": "Genaue Kontonummer eingeben",
  "admin.accounts.filters.username": "Benutzername", 
  "admin.accounts.filters.usernamePlaceholder": "Genauen Benutzernamen eingeben",
  "admin.accounts.filters.accountStatus": "Kontostatus",
  "admin.accounts.filters.accountStatusPlaceholder": "Kontostatus auswählen",
  "admin.accounts.filters.allStatuses": "Alle Status",
  "admin.accounts.filters.dateFrom": "Konto eröffnet ab (yyyy-mm-dd)",
  "admin.accounts.filters.dateTo": "Konto eröffnet bis (yyyy-mm-dd)",
  "admin.accounts.filters.accountShareType": "Konto-Anteilstyp",
  "admin.accounts.filters.accountShareTypePlaceholder": "Anteilstyp auswählen",
  "admin.accounts.filters.allShareTypes": "Alle Anteilstypen",
  "admin.accounts.filters.programPercent": "Programmprozentsatz",
  "admin.accounts.filters.programPercentPlaceholder": "Programmprozentsatz auswählen",
  "admin.accounts.filters.allProgramPercents": "Alle Programmprozentsätze",
  "admin.accounts.filters.balanceMin": "Mindestguthaben",
  "admin.accounts.filters.balanceMinPlaceholder": "Mindestguthaben eingeben",
  "admin.accounts.filters.balanceMax": "Maximalguthaben", 
  "admin.accounts.filters.balanceMaxPlaceholder": "Maximalguthaben eingeben",
  "admin.accounts.filters.applyFilters": "Filter anwenden",
  "admin.accounts.filters.clearFilters": "Filter löschen",

  // Table section
  "admin.accounts.table.title": "Benutzerkonten",
  "admin.accounts.table.showing": "Zeige",
  "admin.accounts.table.of": "von",
  "admin.accounts.table.accounts": "Konten",
  "admin.accounts.table.accountNumber": "Kontonummer",
  "admin.accounts.table.username": "Benutzername",
  "admin.accounts.table.name": "Name",
  "admin.accounts.table.status": "Status",
  "admin.accounts.table.shareType": "Anteilstyp",
  "admin.accounts.table.programPercent": "Programm %",
  "admin.accounts.table.balance": "Guthaben", 
  "admin.accounts.table.creationDate": "Erstellungsdatum",
  "admin.accounts.table.lastUpdate": "Letzte Aktualisierung",
  "admin.accounts.table.errorMessage": "Fehler beim Laden der Kontodaten",
  "admin.accounts.table.noDataMessage": "Keine Konten gefunden, die den aktuellen Filtern entsprechen",

  // Status translations
  "admin.accounts.table.status.active": "Aktiv",
  "admin.accounts.table.status.inactive": "Inaktiv",

  // Profits page translations
  "admin.accounts.profits.pageTitle": "Kontenprofite-Verwaltung",
  "admin.accounts.profits.pageDescription": "Kontenprofite-Verlauf anzeigen und analysieren mit umfassenden Filteroptionen",
  "admin.accounts.profits.title": "Kontenprofite-Verwaltung",
  "admin.accounts.profits.subtitle": "Umfassende Ansicht des Kontenprofite-Verlaufs mit erweiterten Filter- und Analyseoptionen",
  "admin.accounts.profits.errorTitle": "Fehler beim Laden der Profitdaten",
  "admin.accounts.profits.errorMessage": "Fehler beim Laden der Kontenprofitdaten. Bitte versuchen Sie es erneut.",
  "admin.accounts.profits.retryButton": "Erneut versuchen",

  // Profits filters section
  "admin.accounts.profits.filters.title": "Profitfilter",
  "admin.accounts.profits.filters.accountInformationTitle": "Kontoinformationen",
  "admin.accounts.profits.filters.periodTitle": "Zeitraum",
  "admin.accounts.profits.filters.profitsTitle": "Profite",
  "admin.accounts.profits.filters.accountNumber": "Kontonummer",
  "admin.accounts.profits.filters.accountNumberPlaceholder": "Genaue Kontonummer eingeben",
  "admin.accounts.profits.filters.username": "Benutzername",
  "admin.accounts.profits.filters.usernamePlaceholder": "Genauen Benutzernamen eingeben",
  "admin.accounts.profits.filters.accountShare": "Kontoanteil",
  "admin.accounts.profits.filters.accountSharePlaceholder": "Kontoanteilstyp auswählen",
  "admin.accounts.profits.filters.allAccountShares": "Alle Anteilstypen",
  "admin.accounts.profits.filters.dateFrom": "Zeitraum von (yyyy-mm-dd)",
  "admin.accounts.profits.filters.dateTo": "Zeitraum bis (yyyy-mm-dd)",
  "admin.accounts.profits.filters.userProfitRange": "Benutzerprofitbereich",
  "admin.accounts.profits.filters.userProfitMin": "Mindestbenutzerprofit",
  "admin.accounts.profits.filters.userProfitMinPlaceholder": "Mindestbenutzerprofit eingeben",
  "admin.accounts.profits.filters.userProfitMax": "Maximalbenutzerprofit",
  "admin.accounts.profits.filters.userProfitMaxPlaceholder": "Maximalbenutzerprofit eingeben",
  "admin.accounts.profits.filters.tradingProfitRange": "Handelsprofitbereich",
  "admin.accounts.profits.filters.tradingProfitMin": "Mindesthandelsprofit",
  "admin.accounts.profits.filters.tradingProfitMinPlaceholder": "Mindesthandelsprofit eingeben",
  "admin.accounts.profits.filters.tradingProfitMax": "Maximalhandelsprofit",
  "admin.accounts.profits.filters.tradingProfitMaxPlaceholder": "Maximalhandelsprofit eingeben",
  "admin.accounts.profits.filters.programProfitRange": "Programmprofitbereich",
  "admin.accounts.profits.filters.programProfitMin": "Mindestprogrammprofit",
  "admin.accounts.profits.filters.programProfitMinPlaceholder": "Mindestprogrammprofit eingeben",
  "admin.accounts.profits.filters.programProfitMax": "Maximalprogrammprofit",
  "admin.accounts.profits.filters.programProfitMaxPlaceholder": "Maximalprogrammprofit eingeben",
  "admin.accounts.profits.filters.applyFilters": "Filter anwenden",
  "admin.accounts.profits.filters.clearFilters": "Filter löschen",

  // Profits table section
  "admin.accounts.profits.table.title": "Kontenprofitdaten",
  "admin.accounts.profits.table.showing": "Zeige",
  "admin.accounts.profits.table.of": "von",
  "admin.accounts.profits.table.records": "Datensätzen",
  "admin.accounts.profits.table.accountNumber": "Kontonummer",
  "admin.accounts.profits.table.username": "Benutzername",
  "admin.accounts.profits.table.name": "Name",
  "admin.accounts.profits.table.shareType": "Anteilstyp",
  "admin.accounts.profits.table.period": "Zeitraum",
  "admin.accounts.profits.table.userProfit": "Benutzerprofit",
  "admin.accounts.profits.table.tradingProfit": "Handelsprofit",
  "admin.accounts.profits.table.programProfit": "Programmprofit",
  "admin.accounts.profits.table.errorMessage": "Fehler beim Laden der Profitdaten",
  "admin.accounts.profits.table.noDataMessage": "Keine Profitdatensätze gefunden, die den aktuellen Filtern entsprechen",

  // Profits Totals page translations
  "admin.accounts.profitsTotals.title": "Verwaltung der Konto-Gewinn-Gesamtsummen",
  "admin.accounts.profitsTotals.subtitle": "Anzeigen und Analysieren der gesamten Kontogewinne mit umfassenden Filteroptionen",
  "admin.accounts.profitsTotals.errorTitle": "Fehler beim Laden der Gewinn-Gesamtsummen",
  "admin.accounts.profitsTotals.errorMessage": "Fehler beim Laden der Konto-Gewinn-Gesamtsummen. Bitte versuchen Sie es erneut.",
  "admin.accounts.profitsTotals.retryButton": "Wiederholen",

  // Profits Totals filters section
  "admin.accounts.profitsTotals.filters.title": "Gewinn-Gesamtsummen-Filter",
  "admin.accounts.profitsTotals.filters.accountInformationTitle": "Kontoinformationen",
  "admin.accounts.profitsTotals.filters.profitsTitle": "Gewinne",
  "admin.accounts.profitsTotals.filters.accountNumber": "Kontonummer",
  "admin.accounts.profitsTotals.filters.accountNumberPlaceholder": "Geben Sie die exakte Kontonummer ein",
  "admin.accounts.profitsTotals.filters.username": "Benutzername",
  "admin.accounts.profitsTotals.filters.usernamePlaceholder": "Geben Sie den exakten Benutzernamen ein",
  "admin.accounts.profitsTotals.filters.accountShare": "Kontoanteil",
  "admin.accounts.profitsTotals.filters.accountSharePlaceholder": "Wählen Sie den Kontoanteilstyp",
  "admin.accounts.profitsTotals.filters.allAccountShares": "Alle Anteilstypen",
  "admin.accounts.profitsTotals.filters.userProfitRange": "Benutzergewinnbereich",
  "admin.accounts.profitsTotals.filters.userProfitMin": "Minimaler Benutzergewinn",
  "admin.accounts.profitsTotals.filters.userProfitMinPlaceholder": "Geben Sie den minimalen Benutzergewinn ein",
  "admin.accounts.profitsTotals.filters.userProfitMax": "Maximaler Benutzergewinn",
  "admin.accounts.profitsTotals.filters.userProfitMaxPlaceholder": "Geben Sie den maximalen Benutzergewinn ein",
  "admin.accounts.profitsTotals.filters.tradingProfitRange": "Handelsgewinnbereich",
  "admin.accounts.profitsTotals.filters.tradingProfitMin": "Minimaler Handelsgewinn",
  "admin.accounts.profitsTotals.filters.tradingProfitMinPlaceholder": "Geben Sie den minimalen Handelsgewinn ein",
  "admin.accounts.profitsTotals.filters.tradingProfitMax": "Maximaler Handelsgewinn",
  "admin.accounts.profitsTotals.filters.tradingProfitMaxPlaceholder": "Geben Sie den maximalen Handelsgewinn ein",
  "admin.accounts.profitsTotals.filters.programProfitRange": "Programmgewinnbereich",
  "admin.accounts.profitsTotals.filters.programProfitMin": "Minimaler Programmgewinn",
  "admin.accounts.profitsTotals.filters.programProfitMinPlaceholder": "Geben Sie den minimalen Programmgewinn ein",
  "admin.accounts.profitsTotals.filters.programProfitMax": "Maximaler Programmgewinn",
  "admin.accounts.profitsTotals.filters.programProfitMaxPlaceholder": "Geben Sie den maximalen Programmgewinn ein",
  "admin.accounts.profitsTotals.filters.applyFilters": "Filter anwenden",
  "admin.accounts.profitsTotals.filters.clearFilters": "Filter löschen",

  // Profits Totals table section
  "admin.accounts.profitsTotals.table.title": "Konto-Gewinn-Gesamtsummen-Daten",
  "admin.accounts.profitsTotals.table.showing": "Anzeigen",
  "admin.accounts.profitsTotals.table.of": "von",
  "admin.accounts.profitsTotals.table.records": "Einträgen",
  "admin.accounts.profitsTotals.table.accountNumber": "Kontonummer",
  "admin.accounts.profitsTotals.table.username": "Benutzername",
  "admin.accounts.profitsTotals.table.name": "Name",
  "admin.accounts.profitsTotals.table.shareType": "Anteilstyp",
  "admin.accounts.profitsTotals.table.userProfit": "Benutzergewinn",
  "admin.accounts.profitsTotals.table.tradingProfit": "Handelsgewinn",
  "admin.accounts.profitsTotals.table.programProfit": "Programmgewinn",
  "admin.accounts.profitsTotals.table.errorMessage": "Fehler beim Laden der Gewinn-Gesamtsummen",
  "admin.accounts.profitsTotals.table.noDataMessage": "Keine Gewinn-Gesamtsummen gefunden, die den aktuellen Filtern entsprechen",
};